import { StringsType } from "./en"

export const ko: StringsType = {
  bubbleExpiration: {
    expiredTitle: "무료 Premium이 만료되었습니다",
    expiredSubtitle:
      "최고의 PhotoVault 경험을 위해 Premium으로 업그레이드하세요",
    expiredSubtitlePremium:
      "훌륭한 PhotoVault 경험을 위해 Premium으로 업그레이드하세요",
    expiredSubtitleUltimate:
      "최고의 PhotoVault 경험을 위해 Ultimate로 업그레이드하세요",
    trashRecovery: "휴지통 복구",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "광고 없음",
    everyPremiumFeature: "모든 Premium 기능\n획득",
    everyUltimateFeature: "모든 Ultimate 기능\n 획득",
    unlockUltimateTools: "앱의 모든 개인 정보 보호 도구의 잠금을 해제하세요.",
    cloudVaultUltimate: "Cloud Vault - 1,000 GB",
    organizationPlus: "정리+",
    organizationPlusDesc: "하위 앨범 만들기, 중복 항목 찾기 등.",
    perMonth: "월",
    perYear: "연",
    justOnce: "단 한 번",
    lifetime: "평생",
    threeMonths: "3개월",
    lifetimeTitle: "평생 요금제",
    lifetimeDescription:
      "평생 요금제가 곧 출시됩니다. 업데이트를 기다려주세요!",
    lifetimeFeature1: "일회성 결제",
    lifetimeFeature2: "모든 기능에 평생 액세스",
    lifetimeFeature3: "장기 사용자에게 최고의 가치",
    lifetimeCta: "Lifetime 구매",
    lifetimeSheetDisclaimer: "클라우드 백업(50GB) 5년간 포함.",
    lifetimeSheetDisclaimerDetailed:
      "라이프타임 플랜에는 5년간의 Cloud Vault 백업(50 GB)이 포함되어 있습니다. 그 후에는 라이프타임 멤버만 이용할 수 있는 할인된 Cloud Vault 구독을 이용할 수 있습니다. 모든 프리미엄 기능은 추가 비용 없이 항상 이용 가능합니다.",
    lifetimeDisclaimerCloudStorage:
      "라이프타임 플랜에는 5년간의 Cloud Vault 백업(50 GB)이 포함되어 있습니다.",
    lifetimeDisclaimerAfterPeriod:
      "5년 후에는 라이프타임 멤버만 이용할 수 있는 할인된 Cloud Vault 구독을 이용할 수 있습니다.",
    lifetimeDisclaimerPremiumFeatures:
      "모든 프리미엄 기능은 추가 비용 없이 항상 이용 가능합니다.",
    monthly: "월간",
    yearly: "연간",
    selectPlan: "계속할 요금제를 선택하세요",
    unlockPrivacyTools: "뛰어난 개인 정보 도구를 해제하세요.",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "암호화된 상태로 유지되는 안전한 백업.",
    freeUpSpace: "핸드폰의 공간을 확보하세요.",
    recoverDeleted: "휴지통에서 삭제된 항목을 복구하세요.",
    fullExperience: "방해 없는 완전한 경험.",
    restorePurchases: "구매 복구",
    basicTitle: "Private Photo Vault Basic",
    free: "무료",
    basicDescription:
      "Basic은 PhotoVault의 무료 버전입니다. PIN 화면 뒤에 중요한 사진을 보호하고 좋은 개인정보 보호 기능을 제공합니다.",
    switchToBasic: "Basic으로 전환",
    termsOfService: "서비스 약관",
    privacy: "개인정보 보호",
    switchToPremium: "Premium으로 전환",
    switchToUltimate: "Ultimate로 전환",
    premiumExpiredTitle: "Premium이 만료되었습니다",
    ultimateExpiredTitle: "Ultimate가 만료되었습니다",
    renewSubtitle: "최고의 Private Photo Vault 경험을 위해 갱신하세요",
    selectPlanOrSwitchToPro: "플랜을 선택하거나 무료로 Pro로 전환하세요",
    selectPlanOrSwitchToBasic: "플랜을 선택하거나 무료로 Basic으로 전환하세요",
    proTitle: "Private Photo Vault - Pro",
    purchased: "구매됨",
    proDescription:
      "이전에 일회성 Pro 버전을 구매하셨으므로 이전에 결제한 모든 Pro 기능을 계속 사용하실 수 있습니다.",
    switchToPro: "Pro로 전환",
    subscribeFor: (price: string) => `${price}/년 구독하기`,
    subscribeForMonth: (price: string) => `${price}/월 구독하기`,
    billedPerYear: (price: string) => `연간 ${price} 청구`,
    oneStepSubtitle:
      "최고의 Private Photo Vault 경험을 위해\n프리미엄으로 업그레이드하세요",
    oneStepSubtitleUltimate:
      "최고의 Private Photo Vault 경험을 위해\nUltimate로 업그레이드하세요",
    purchaseWithAppStore: "App Store에서 구매",
  },
  title: "모든 기능에 무제한 액세스",
  freeTrial: "무료 체험",
  startPlan: "요금제 시작",
  pricePerMonth: (price: any) => `${price}/월`,
  pricePerYear: (price: any) => `${price}/년으로 청구`,
  freeTrialDescriptionYearly: (days: number, price: string) =>
    `${days}일 무료 후 ${price}/년. 언제든 취소`,
  freeTrialDescriptionMonthly: (days: number, price: string) =>
    `${days}일 무료 후 ${price}/월. 언제든 취소`,
  discount: (discount: number) => `${discount}% 할인"`,
  new: "신규",
  trashRecovery: "쓰레기 복구",
  adFree: "무광고 사용",
  breakIn: "침입 보고: 사진 및 GPS",
  wireless: "무선 사진 전송",
  decoy: "미끼 비밀번호",
  pattern: "패턴 잠금",
  appDisguise: "앱 위장",
  comingSoon: "곧 출시",
  subscriptionTerms: "구독 조건:",
  terms:
    "결제는 구매 확인시 iTunes 계정으로 청구됩니다. 현재 기간이 끝나기 최소 24시간 전에 자동 갱신을 끄지 않으면 구독이 자동으로 갱신됩니다. 현재 기간이 끝나기 24시간 내에 계정에 갱신 요금이 청구됩니다. 구매 후 '계정 설정'으로 이동하셔서 구독을 관리하고 자동 갱신을 끄실 수 있습니다.",
  privacy: "개인 정보 보호",
  alreadyPurchased: "이미 구매하셨습니까?",
  termsButton: "조건",
  monthly: "월간",
  yearly: "연간",
  popular: "인기",
  save: (discount) => `${discount}% 할인`,
  anniversaryTitle: (discount) => `기념일 특가 - ${discount}% 할인`,
  blackFridayTitle: (discount) => `블랙 프라이데이 - ${discount}% 할인`,
  year: "년",
  years: "년",
  hour: "시간",
  hours: "시간",
  minute: "분",
  minutes: "분",
  second: "초",
  seconds: "초",
  promoSubtitle: (hours) =>
    `서두르세요, 이 세일은 ${hours} 시간 동안만 지속됩니다`,
  offerExpires: "제안이 만료될 때까지",
  unlockDeal: "딜 잠금 해제",
  blackFridayPaywallTitle: "블랙 프라이데이 딜",
  anniversaryPaywallTitle: "당신의 기념일 오차 🎉",
  blackFridayPaywallSubtitle:
    "블랙 프라이데이의 이번 기회를 놓치지 마세요! 연간 구독에서 큰 할인 혜택을 받아보세요.",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `${years}년 동안 함께한 것을 축하합니다! 기념으로 프리미엄에서 ${discount}% 할인 혜택을 드립니다. 충성을 감사드립니다!`,
  blackFridayAnnualTitle: "당신의 블랙 프라이데이 오차 🎉",
  anniversaryAnnualTitle: "당신의 기념일 오차 🎉",
  oneYear: "1년",
  oneMonth: "1개월",
  lockedIn: "이 연간 가격은 영원히 잠겨질 것입니다",
  subtitleFixed: "서두르세요, 이 할인은 곧 종료됩니다!",
  importTitle: "금고 시작하기",
  importSubtitle: "100% 비공개입니다!",
  importInfo: "숨기고 안전하게 보관하고 싶은 사진과 동영상을 추가하세요.",
  importCTA: "금고에 추가",
  skip: "건너뛰기",
  totalMonthsPrice: (price: string) => `12개월 • ${price}`,
  monthlyPrice: (price: string) => `${price} / 월`,
  oneTimeOffer: {
    title: "당신의 일회용 오퍼",
    subTitle: "일회용 오퍼를 닫으면, 그것은 사라집니다!",
    claim: "당신의 일회용 오퍼를 청구하세요",
  },
  returnOffer: {
    monthly: (price: string) => `월 ${price} 이하`,
    title: "독점 복귀 제안",
    subTitle:
      "오늘 특별 요금으로 회원 자격을 재활성화하세요! 제한된 시간에만 가능",
    discountTitle: "특별 할인",
    cta: "지금 재활성화",
    discountSubTitle: "한정 시간 제공",
  },
  off: "할인",
  special: "특별",
  yearlyPlan: "연간 계획",
  monthlyPlan: "월간 계획",
  subscribe: "구독",
  cancelAnytime: "언제든지 취소",
  freeTrialPaywall: {
    title: "무료 체험 방법",
    firstStep: {
      title: "지금",
      subtitle:
        "Private Photo Vault에 무제한 접근을 허용하고 개인 사진을 누군가가 보는 것에 대해 걱정하지 마세요",
    },
    secondStep: {
      title: "오늘: 무료 체험 시작",
      subtitle:
        "PhotoVault에 전체 접근을 허용합니다. 오늘은 요금이 청구되지 않습니다.",
    },
    thirdStep: {
      title: "7일 후",
      subtitle: "이날 요금이 청구됩니다. 언제든지 취소할 수 있습니다.",
    },
    whatsIncluded: "포함된 내용 보기",
    viewAllPlans: "모든 플랜 보기",
    startTrial: "무료 체험 시작",
    footerTitle: (yearlyPrice, monthlyPrice) =>
      `7일 무료 체험 후 ${yearlyPrice}/년\n(월 ${monthlyPrice})`,
    footerDisclaimer:
      "체험 종료 전에 언제든지 취소할 수 있습니다. 7일 후에만 요금이 청구됩니다.",
    featureList: {
      title: "Private Photo Vault란?",
      infoTitle: "100% 개인 및 보안",
      infoSubtitle: "데이터를 보호하고 무단 접근을 방지합니다",
      subTitle: "프리미엄으로 업그레이드하고 다음을 이용하세요:",
    },
    comparePlans: {
      monthly: "월간",
      yearly: "연간",
      threeMonths: "3개월",
      ultimateYearly: "Ultimate 연간 요금제",
      freeFor: (days) => `${days}일 동안 무료`,
      monthlyPrice: (price) => `월 ${price}만`,
      dailyPrice: (price) => `하루 ${price}만`,
      cta: "계속",
    },
  },
  comparePlans: {
    title: "계획 비교",
    compare: "비교",
    freeTitle: "무료",
    basicTitle: "기본",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Premium 잠금 해제",
    unlockUltimate: "Ultimate 잠금 해제",
    choose: "플랜 선택",
  },
  features: {
    organizationPlus: "조직+",
    securityPlus: "보안+",
    duplicateDetection: "중복 감지",
    faceDownLock: "화면을 아래로 하고 잠금",
    customIcons: "맞춤형 아이콘",
    encryptedStorage: "암호화된 사진 저장소",
    unlimitedAlbums: "무제한 앨범",
    browser: "보안 웹 브라우저",
    camera: "개인 카메라",
    subalbums: {
      title: "하위 앨범",
      description:
        "여러 수준의 하위 앨범을 만들어 콘텐츠를 효율적으로 구성하세요.",
    },
    filteringAndSearching: {
      title: "필터링 및 검색",
      description:
        "앨범을 검색하고 필터를 적용하여 특정 콘텐츠 유형을 찾으세요.",
    },
    alphanumericPasscode: {
      title: "영숫자 비밀번호",
      description: "영숫자 비밀번호를 사용하여 앱의 보안을 강화하세요.",
    },
    dualLock: {
      title: "비밀번호 + Face ID 필요",
      description:
        "추가 보안을 위해 앱에 들어갈 때마다 비밀번호와 Face ID가 필요합니다.",
    },
    locationBasedLock: {
      title: "위치 기반 잠금",
      description:
        "승인된 GPS 위치에서만 앱 잠금을 해제할 수 있도록 허용합니다.",
    },
  },
  gotIt: "알겠습니다!",
  promo: {
    premiumSave: (percent: string) => `PREMIUM에서 ${percent}% 절약`,
    monthly: (price: string) => `매달 ${price}`,
    yearly: (price: string) => `연 ${price}`,
    limited: "제한된 시간 남음",
    claimOffer: "제안 받기",
    seconds: (count: number) => (count == 1 ? "초" : "초"),
    minutes: (count: number) => (count == 1 ? "분" : "분"),
    oneTimeOffer: "한 번만의 제안",
    normalFee: "일반 요금",
    backTo: "돌아가기",
    yearlyShort: (price: string) => `연간 ${price}`,
  },
  premiumToUltimateBlackFriday: {
    title: "블랙 프라이데이 세일",
    subTitle: "ULTIMATE로 업그레이드",
    cloud: {
      title: "1,000GB 클라우드 저장소",
      description: "50만 장 이상의 사진을 안전하게 보관",
    },
    duplicateDetection: {
      description: "중복 이미지를 찾아 제거",
    },
    organizationPlus: {
      description: "서브 앨범을 생성하고 사진을 필터링 및 검색",
    },
    securityPlus: {
      description: "알파벳 숫자 암호, 위치 기반 잠금 등으로 보안 강화",
    },
    timeRemaining: "남은 시간",
    saleBanner: "기간 한정 메가 세일",
    saleTitle: "블랙 프라이데이 세일 🎉",
    bannerTitle: (discount: number) => `블랙 프라이데이 ${discount}% 할인`,
    bannerCTA: "혜택 받기",
    monthPrefix: "12개월 • ",
    perMonthPrice(price: string) {
      return `${price} / 월`
    },
    monthly: "월별",
    ultimateLaunch: {
      title: "Ultimate로 업그레이드",
      saleTitle: "Ultimate 출시 세일 🚀",
      bannerTitle: (discount) => `Ultimate 출시 - ${discount}% 절약`,
    },
  },
  blackFridayNoFeatures: {
    title: "BLACK FRIDAY",
    lessThanCoffee: "커피보다 저렴합니다.",
    dontWait: "기다리지 마세요! 이 혜택은 곧 사라집니다",
    whatWaiting: "무엇을 기다리고 계신가요?",
    claimOffer: "단 한 번의 특가 혜택 받기",
    moneyBack: "환불 보장",
  },
  cyberMonday: {
    title: "CYBER MONDAY",
    subTitle: "ULTIMATE 받기",
    cloud: {
      title: "1,000GB 클라우드 스토리지",
      description: "500,000개 이상의 사진을 위한 안전한 클라우드 스토리지",
    },
    duplicateDetection: {
      description: "중복 이미지 찾기 및 삭제",
    },
    organizationPlus: {
      description: "하위 앨범 만들기, 필터링 및 사진 검색",
    },
    securityPlus: {
      description: "영숫자 비밀번호, 위치 기반 잠금 등 향상된 보안",
    },
    timeRemaining: "남은 시간",
    saleBanner: "한정 시간 사이버 특가",
    saleTitle: "사이버 먼데이 세일",
    bannerTitle: (discount: number) => `사이버 먼데이 ${discount}% 할인`,
    bannerCTA: "혜택 받기",
    monthPrefix: "12개월 • ",
    perMonthPrice(price: string) {
      return `${price} / 월`
    },
    monthly: "월별",
    ultimateLaunch: {
      title: "Ultimate로 업그레이드",
      saleTitle: "Ultimate 출시 세일",
      bannerTitle: (discount: number) =>
        `Ultimate로 업그레이드 - ${discount}% 절약`,
    },
  },
  beforeYouGo: {
    title: "잠깐 - 떠나기 전에",
    subtitle: "사진을 안전하고 개인적으로 보관하세요",
    subtitle2: "프리미엄을 7일 동안 완전히 무료로 이용하세요.",
    cta: "무료 체험 시작",
    cancelTitle:
      "시험 기간이 끝나기 전에 언제든지 취소할 수 있으며, 7일이 완료될 때까지 요금이 청구되지 않습니다.",
    skipCta: "괜찮습니다",
  },
  enableTrial: "아직 확신이 안 드시나요? 무료 체험 활성화",
  startTrial: "무료 체험 시작",
  trialActivated: (days) => `${days}일 체험이 활성화되었습니다`,
  specialOffer: {
    enabledTitle: "특별 혜택 활성화됨",
    trialTitle: "추가 7일 무료 체험을 받아보세요",
    expirationTitle: "구독이 곧 만료됩니다!",
    expirationSubtitle: "특별한 요금으로 구독을 갱신하세요!",
    priceBoxExpiration: {
      title: "특별 갱신 혜택",
      offerName: "연간 요금제",
      ctaTitle: "특별 혜택 받기",
    },
    priceBoxTrial: {
      title: "독점 제공: 추가 7일 무료 체험",
      offerName: "추가 7일 체험",
      ctaTitle: "무료 체험 받기",
    },
  },
  premiumToUltimate: {
    titleLine1: "ULTIMATE 업그레이드",
    titleLine2: "단 한 번의 제안",
    megaSaleBanner: "기간 한정 메가 세일",
    upgradeTitle: "Ultimate 업그레이드 세일",
    yearlySubtitlePrefix: "12개월 •",
    monthlyPriceSuffix: "/ 월",
  },
  monthlyToYearly: {
    titleLine1: "연간 업그레이드",
    titleLine2: "단 한 번의 제안",
    subtitleWarning: "이 단 한 번의 제안을 닫으면 다시 볼 수 없습니다!",
    specialLabel: "스페셜",
    offerTitle: "단 한 번의 제안 받기",
    offerName: "연간 플랜",
    subscribeButton: "구독하기",
    cancelAnytime: "언제든지 해지 가능",
    yearlySubtitlePrefix: "12개월 •",
    monthlyPriceSuffix: "/ 월",
  },
  expiration: {
    warmup: {
      close: "닫기",
      subtitle:
        "휴대폰을 분실하거나 도난당해도 사진을 안전하고 복구 가능하게 유지하세요",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "파일의 암호화 백업",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1,000GB Cloud Vault 저장 공간",
        },
        reviews: {
          title: "50만 개 이상의 별 5개 리뷰",
          subtitle: "수백만 명의 신뢰",
        },
        noAds: {
          title: "광고 없음",
          subtitle: "광고 없는 경험",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "하위 앨범, 향상된 필터링 등",
        },
      },
      footer: "& 모든 기능 포함!",
      switchToPremium: "Premium으로 전환",
      switchToUltimate: "Ultimate로 전환",
      titlePremium: "Premium이 만료되었습니다!",
      titleUltimate: "Ultimate가 만료되었습니다!",
      popular: "인기",
      perMonth: "월별",
      perYear: "연간",
    },
    titlePremium: "Premium이 만료됨",
    titleUltimate: "Ultimate가 만료됨",
    subtitlePremium:
      "모든 기능을 유지하려면 Premium을 갱신하거나 무료로 Basic으로 전환하세요",
    subtitleUltimate:
      "모든 기능을 유지하려면 Ultimate을 갱신하거나 무료로 Basic으로 전환하세요",
    basicButton: "Basic으로 전환",
    basicTitle: "Basic이란?",
    basicDescription:
      "Basic은 앱의 무료 버전입니다. 여전히 PIN으로 사진과 비디오를 보호할 수 있지만, Cloud Vault 암호화 백업 및 기타 Premium 기능은 사용할 수 없습니다",
  },
  animated: {
    title: "요금제를 선택하세요",
    yearlyPrice: (price: string) => `연간 ${price}만`,
    subtitle: "자동 갱신. 언제든지 취소 가능",
    cta: "계속",
    trial: "무료 체험 활성화됨",
    breakinShort: "침입 보고서",
    unlimitedPhotos: "무제한 사진",
  },
  choosePlanTitle: "플랜 선택",
  socialProof: {
    titleWithTrial: "Private Photo Vault 체험하기\n7일 무료",
    title: "Private Photo Vault 체험하기",
    continueForFree: "무료로 계속",
    continue: "계속",
    cancelAnytime: "언제든 취소 가능",
    mostPopular: "가장 인기",
    twelveMonths: "12개월",
    oneMonth: "1개월",
    yearlySubtitle: (monthlyPrice: string, yearlyPrice: string) =>
      `${monthlyPrice}/월, ${yearlyPrice}/년으로 청구`,
    monthlySubtitle: (price: string) => `${price}/월`,
  },
  yearlyOnlyAppStore: {
    yearly: "연간",
    billedYearly: (price: string) => `연 ${price} 청구`,
    perMonth: (price: string) => `${price}/월`,
    startTrial: (days: number) => `${days}일 무료 체험 시작`,
    purchaseWithAppStore: "App Store에서 구매  (체험 없음)",
    purchaseImmediately: "즉시 구매  (체험 없음)",
  },
  multistep: {
    lockTitle: "비공개 사진 잠금",
    subtitle: {
      line1: "우리는",
      line2: "7일 무료 제공",
      line3: "모두가 사진을 보호할 수 있도록",
    },
    subtitleReminder: {
      line1: "체험 종료 ",
      line2: "2일 전 ",
      line3: "에 알림을 드립니다.",
    },
    noPaymentNow: "지금 결제 없음",
    startFreeWeek: "무료 1주일 시작",
    payTitle: "7일 무료",
    afterPrice: (price: string) => `그 후 ${price} / 월`,
    afterBilling: (price: string) => `(체험 후 연간 ${price}로 청구됨)`,
    footerTitle: (price) => `7일 무료. 이후 ${price}/년`,
    footerMonthlyTitle: (price) => `${price}가 즉시 청구됩니다.`,
    headerTitle: "7일 무료 체험",
    anual: "연간",
    monthly: "월간",
    noTrial: "무료 체험 없음",
    yearlyPrice: (price) => `${price} / 년`,
  },
  oneTimeOfferTitle: "단 한 번의 특별 제안",
  unlockPremiumFor: "연간 Premium을 다음 가격에 이용:",
  oneTimeOfferSubtitle: "이번 제안은 단 한 번뿐입니다",
  lowestPrice: "역대 최저가",
  summerSale: {
    title: "여름 세일",
    tagline: "태양은 모든 것을 보고 있어요... 당신의 금고 안 빼고요!",
    timeRemaining: "거래가 공 끝납니다",
    limitedTimeOffer: "한정 시간 특가",
    savePercent: (percent: number) => `${percent}% 할인`,
    bannerSubtitle: (price: string) => `${price}에 Premium 획듍`,
    bannerSubtitleUltimate: (price: string) => `${price}에 Ultimate 획득`,
    getPremium: "Premium 개인정보 보호 받기",
    getUltimate: "Ultimate 개인정보 보호 받기",
    hours: "시간",
    minutes: "분",
    seconds: "초",
    features: {
      premiumFeature: {
        title: "모든 Premium 기능 획듍",
        description: "개인 정보를 보호하는 Premium 도구.",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "암호화된 상태로 유지되는 안전한 백업.",
      },
      noAds: {
        title: "광고 없음",
        description: "방해 없는 완전한 경험.",
      },
      faceDownLock: {
        title: "페이스 다운 잠금",
        description: "휴대폰을 뒤집어 앱을 즉시 잠금.",
      },
      breakInReports: {
        title: "침입 보고서",
        description: "누군가 금고에 접근하려고 하면 경고.",
      },
    },
    pricing: {
      summerSale: "여름 세일",
      monthly: "월간",
      perMonth: (price: string) => `${price} / 월`,
      twelveMonths: "12개월",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  autumnSale: {
    title: "가을 세일",
    tagline: "낙엽이 모든 것을 덮습니다…\n당신의 비밀도 포함해서!",
    buttonTitle: "가을 세일",
  },
  halloweenSale: {
    title: "할로윈 세일",
    tagline: "밤은 많은 것을 숨깁니다…\n특히 당신의 것을!",
    buttonTitle: "할로윈 세일",
  },
  winterSale: {
    title: "겨울 세일",
    tagline: "눈 아래에서 사진을 보호하세요",
    buttonTitle: "겨울 세일",
  },
  springSale: {
    title: "봄 세일",
    tagline: "이 독점 봄 할인으로 프리미엄으로 업그레이드하세요",
    ultimateTagline: "이 독점 봄 할인으로 얼티밋으로 업그레이드하세요",
    buttonTitle: "봄 세일",
  },
  emailPromo: {
    title: "독점 Premium 제안",
    upgradeButton: "Premium으로 업그레이드",
    yearlyTitle: "Premium 연간",
    decoyDescription: "미끼 비밀번호로 열리는 가짜 보관함 생성",
  },
  tabsPaywall: {
    premiumTab: "Premium",
    ultimateTab: "Ultimate",
    premiumTitle: "Premium을 잠금 해제하여",
    premiumTitleHighlight: "금고를 보호하세요",
    ultimateTitleStart: "",
    ultimateTitleHighlight: "Ultimate",
    ultimateTitleEnd: "을 잠금 해제하여\n모든 기능에 액세스하세요",
    perMonth: "/월",
  },
  trialFooter: {
    freeTrialDays: (days: number) => `${days}일\n무료 체험`,
    noFreeTrial: "무료 체험\n없음",
    noCommitment: "약정 없음. 언제든 취소 가능.",
    cta: "$0로 체험하기",
    ctaMonthly: "계속",
    yearly: "연간",
    monthly: "월간",
  },
  onboardingUltimateAlternate: {
    title: "무료 체험 시작하기",
    premiumDescription: "우수한 프라이버시 도구를 잠금 해제하세요.",
    ultimateDescription: "최고의 Photo Vault 경험.",
    includesPremium: "Premium 포함",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7일 무료, 이후 ${yearlyPrice} (${monthlyPrice}/월)`,
    timeline: {
      today: "오늘:",
      todayDescription: "무료 체험 시작",
      day5: "5일째:",
      day5Description: "알림 받기",
      day7: "7일째:",
      day7Description: (yearlyPrice: string) => `${yearlyPrice}가 청구됩니다`,
    },
    comparisonTable: {
      header: "받을 수 있는 것",
    },
    didYouKnow: {
      label: "알고 계셨나요?",
      statNumber: "3배",
      statDescription: "구독자는 3배 더 많은 마음의 평화를 얻습니다",
    },
    pricing: {
      yearlyPlanTitle: "연간 플랜",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/년`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/월`,
      monthlyTitle: "월간",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/월`,
      popularBadge: "인기",
    },
    ctaButton: "무료 체험 시작",
  },
  threeStepExpiration: {
    premiumExpired: "Premium이 만료되었습니다",
    ultimateExpired: "Ultimate 구독이 만료되었습니다",
    freeExpired: "무료 Premium이 만료되었습니다",
    subtitle: "계정이 다운그레이드되었습니다.",
    subtitlePremium: "계정이 다운그레이드되었습니다.",
    subtitleUltimate: "계정이 다운그레이드되었습니다.",
    allPremiumFeatures: "모든 Premium 기능",
    allUltimateFeatures: "모든 Ultimate 기능",
    spaceSaver: "공간 절약",
    disabled: "비활성화됨",
    restoreMyProtection: "전체 액세스 복원",
    seeWhatImLosing: "잃게 되는 것 확인",
    photosSafeWarning: "사진은 안전하지만 중요한 기능이 비활성화되었습니다.",
    continue: "계속",
    heresWhatYoureLosing: "잃게 되는 것들",
    allFeaturesDisabled: "다음의 모든 프리미엄 기능이 계정에서 비활성화됩니다:",
    allFeaturesDisabledUltimate:
      "다음의 모든 얼티밋 기능이 계정에서 비활성화됩니다:",
    back: "뒤로",
    stepOf: (current: number, total: number) =>
      `${total}단계 중 ${current}단계`,
    restoreAllFeatures: "모든 기능 복원",
    continueWithout: "계속 (기능 비활성화 유지)",
    allPremiumDetail:
      "개인 사진을 안전하고 정리된 상태로 유지하는 모든 프리미엄 기능에 대한 액세스를 잃게 됩니다.",
    cloudVaultDetail:
      "클라우드 백업이 삭제됩니다. 기기를 분실하거나 손상되면 개인 사진이 영구적으로 삭제됩니다.",
    cloudVaultDetailBold: "클라우드 백업이 삭제됩니다.",
    cloudVaultDetailRest:
      "기기를 분실하거나 손상되면 개인 사진이 영구적으로 삭제됩니다.",
    spaceSaverDetail:
      "사진이 기기의 전체 저장 공간을 차지합니다. 더 이상 금고를 압축하고 최적화할 수 없습니다.",
    trashDetail:
      "실수로 삭제된 사진은 복구할 수 없습니다. 한 번 삭제되면 영구적으로 사라집니다.",
    noAdsDetail:
      "앱 전체에 광고가 표시됩니다. Premium은 중단 없는 경험을 위해 모든 광고를 제거합니다.",
    decoyDetail:
      "미끼 비밀번호가 작동하지 않습니다. 이를 아는 사람이 실제 금고에 접근할 수 있습니다.",
    chooseYourPlan: "플랜 선택",
    restoreFullProtection: "전체 보호를 즉시 복원",
    restorePremiumInstantly: "Premium을 즉시 복원",
    restoreUltimateInstantly: "Ultimate을 즉시 복원",
    instantlyRestored: "즉시 복원됨",
    reassurance:
      "중단한 곳에서 바로 다시 시작하세요 — 구독하는 순간 모든 기능이 완전히 복원됩니다.",
    subscribeAndRestore: "구독 및 복원",
    scrollForMore: "더 보려면 스크롤",
    bestValue: "최고 가치",
    switchToBasicDescription:
      "앱에서 기존의 모든 사진을 계속 보고 액세스할 수 있습니다. 앨범과 미디어는 기기에서 안전하게 유지됩니다.",
    viewAndAccess: "기존의 모든 사진을 보고 액세스",
    premiumFeaturesDisabled: "",
    restorePremium: "Premium 복원",
    restoreUltimate: "Ultimate 복원",
    choosePlanToReactivate: "모든 기능을 다시 활성화할 플랜을 선택하세요",
    perMonth: "/월",
    twelveMonths: "연간",
    oneMonth: "1개월",
  },
  backupPaywall: {
    title: "백업이 활성화되지 않았습니다",
    subtitle:
      "사진과 동영상이 백업되지 않았습니다. Premium을 구독하여 백업을 활성화하고 모든 기능을 잠금 해제하세요",
    subscribe: "Premium 받기",
    cancelAnytime: "약정 없음. 언제든지 취소 가능",
  },
  lossAversion: {
    title: "단 한 장의 사진도\n백업된 적이 없습니다.",
    subtitle:
      "모든 사진이 이 기기에만 저장되어 있습니다. 잃어버리면 영원히 사라집니다.",
    photosUnprotected: "보호되지 않은\n사진",
    backedUp: "백업됨",
    daysAtRisk: "위험에 처한 일수",
    backupCoverage: "백업 범위",
    vaultProtected: (percent: number) => `보관함의 ${percent}%가 보호됨`,
    premiumTitle: "Premium으로 얻는 것",
  },
}
